export default __webpack_public_path__ + "static/media/DSC_0901.31a51e18.JPG";